<template>
  <div class="text-left">
    <div class="flex justify-between -mb-4">
      <div class="title">
        <slot name="title">title</slot>
      </div>
      <div>
        <el-pagination background layout="prev,next" :total="total" @current-change="handleCurrentChange" class="page">
        </el-pagination>
      </div>
    </div>
    <div class="flex mt-6">
      <div class="mr-3 w-1/6 flex-auto">
        <div class="py-[0.35rem] h-full">
          <img class="img card" :src="img" alt @click="toPath" />
          <!-- <span>{{goUrl}}</span> -->
        </div>
      </div>
      <div class="w-5/6">
        <PublicList v-bind="$attrs" v-slot="{ item }">
          <Item :item="item"></Item>
        </PublicList>
      </div>
    </div>
  </div>
</template>

<script>
import PublicList from "../base/list.vue";

import Item from "../base/item.vue";
export default {
  components: {
    PublicList,
    Item,
  },

  props: {
    img: String,
    total: Number,
    goUrl: String,
  },
  setup(props, ctx) {
    const handleCurrentChange = (val) => {
      ctx.emit("current", val);
    };
    const toPath = () => {
      if (props.goUrl) {
        ctx.root.$router
          .push({
            path: props.goUrl
          })
          .catch(() => { });

      }
    }
    return { handleCurrentChange, toPath };
  },
};
</script>

<style scoped lang="scss">.title {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
}
.more::after {
  content: " >";
}
::v-deep .page button i {
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  --tw-scale-z: 1.5;
}</style>
